import { DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {
	GameAssignmentContext,
	IGameAssignmentContext,
} from 'modules/Entertainment/Games/GameAssignment/gameAssignmentState/gameAssignmentContext';
import React, { useContext } from 'react';
import style from './SelectedOptionsButton.module.scss';

const SelectedOptionsButton: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCustomers } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const iconClasses = classNames(style.icon, { [style.rotated]: isShowBreadcrumbs });

	const emptyCustomers = !Object.keys(IDsSelectedCustomers).length;

	const toggleShowBreadcrumbs = () => {
		setShowBreadcrumbs();
	};

	return (
		<Button
			data-test="SelectedOptionsButton"
			className={style.container}
			theme="outlinedPurple"
			iconPosition="post"
			disabled={emptyCustomers}
			icon={<DownOutlined className={iconClasses} />}
			onClick={toggleShowBreadcrumbs}>
			<Text translationNameSpace="listing" translationKey="selectedOptionsLabel" asFragment={true} />
		</Button>
	);
};

export default SelectedOptionsButton;
